import {Box} from "@mui/system";
import {Button, Typography} from "@mui/material";
import {SponsorComponent} from "../event/components/SponsorsComponent";
import {useSearchParams} from "react-router-dom";
import {AgeGroup, ClimbingEvent} from "../../models/ClimbingEvent";
import {useEffect, useState} from "react";
import {findEventWithName} from "../../services/events/EventService";
import {AppBarComponent} from "../../components/AppBar/AppBarComponent";
import {DifficultyCategory} from "../../models/UserClimbingEvent";
import {Sex} from "../../models/UserData";
import {useTranslation} from "react-i18next";
import {ResultListComponent} from "./components/ResultListComponent";
import {useAuth} from "../../firebase/firebaseAuth";
import {SelectGroupsComponent} from "./components/SelectGroupsComponent";
import {StatisticsComponent} from "./components/StatisticsComponent";

type Option = {
    difficulty?: DifficultyCategory, sex?: Sex, ageGroup?: AgeGroup, section: boolean | undefined
}
const options: Option[] =
    [
        {difficulty: DifficultyCategory.LIGHT, sex: undefined, section: undefined},
        {difficulty: DifficultyCategory.LIGHT, sex: Sex.FEMALE, section: undefined},
        {difficulty: DifficultyCategory.LIGHT, sex: Sex.MALE, section: undefined}
    ]

export const ResultsPage = () => {
    const {t} = useTranslation();
    const [searchParams] = useSearchParams();
    const eventId = searchParams.get('eventId');
    const [event, setEvent] = useState<ClimbingEvent>()
    const [ageCategory, setAgeCategory] = useState<AgeGroup>()
    const [option, setOption] = useState<Option>(options[0])
    const {userData} = useAuth()
    const [shouldScroll, setShouldScroll] = useState<'first' | 'yes' | 'no'>('first')
    const [showStats, setShowStats] = useState(false)
    useEffect(() => {
        if (eventId) {
            findEventWithName(eventId).then((event) => {
                setEvent(event || undefined)
            })
        }
    }, [eventId])

    useEffect(() => {
        const difficulty = searchParams.get('difficulty');
        if (userData && shouldScroll === 'first' && difficulty) {
            setOption(options.find(o => o.difficulty === difficulty && o.sex === userData.sex) || options[0])
            setShouldScroll('yes')
        }
    }, [userData, shouldScroll, searchParams])

    useEffect(() => {
        const ageGroup = Number(searchParams.get('ageGroup'))
        if (ageGroup && event) {
            const ag = event.ageGroups.find(a => a.id === ageGroup)
            setAgeCategory(ag)
        }
    }, [event, searchParams])

    const changeOption = (option: Option) => {
        setOption(option)
        setShowStats(false)
        setShouldScroll('no')
    }

    const getSexLabel = (option: Option): string => {

        if (option.sex === undefined) {
            return "Wszyscy"
        } else {
            return option.sex === Sex.MALE ? t('user.gender.men') : t('user.gender.women')
        }
    }

    return <Box>
        <AppBarComponent/>
        {event &&
            <Box sx={{display: "flex", alignItems: "center", flexDirection: "column", mt: 2}}>
                <Typography variant={"h5"}>{t('results.label')} {event?.name} </Typography>
                <SponsorComponent/>
                <Box sx={{display: "flex", alignItems: "center"}} gap={1} m={1}>
                    {options.map((opt) =>
                        <Button size="small" key={opt.sex + "_" + opt.difficulty}
                                variant={(!showStats && opt === option) ? 'contained' : 'outlined'}
                                onClick={() => changeOption(opt)}>
                            <Typography
                                fontSize={"x-small"}>{getSexLabel(opt)} {Object.keys(DifficultyCategory).length > 1 && opt.difficulty !== undefined && t(`event.categories.${opt.difficulty.toLowerCase()}`)} {event.allowSection && (opt.section ? ` ${t('event.section')}` : ` ${t('event.noSection')}`)}</Typography>
                        </Button>
                    )}
                    <Button size="small" variant={showStats ? 'contained' : 'outlined'}
                            onClick={() => setShowStats(!showStats)}>
                        <Typography fontSize={"x-small"}>{t('results.stats')}</Typography>
                    </Button>
                </Box>
                <Box sx={{display: "flex", justifyContent: "center", gap: "40px"}}>
                    {event.ageGroups && event.ageGroups.length > 1 &&
                        <SelectGroupsComponent groups={event.ageGroups} selectedId={ageCategory?.id}
                                               setGroup={id => setAgeCategory(event.ageGroups.find(ageGroup => ageGroup.id === id))}
                                               id="age-group" label={t('results.ageGroup.label')}/>
                    }
                </Box>

                {
                    showStats && <StatisticsComponent climbingEvent={event}/>
                }

                {
                    !showStats &&
                    <ResultListComponent climbingEvent={event} sex={option.sex}
                                         difficulty={option.difficulty}
                                         ageGroup={ageCategory}
                                         section={option.section} shouldScroll={shouldScroll === 'yes'}
                                         userName={userData?.name}/>
                }

            </Box>
        }
        {
            !event &&
            <Box sx={{display: "flex", alignItems: "center", flexDirection: "column"}}>
            </Box>
        }
    </Box>
}